<template>
  <section class="common-header">
    <!-- 面包屑 -->
    <div class="header-options">
      <div
        class="header-user"
        @mouseleave="downLeave('user')"
        @mouseenter="downEnter('user')"
      >
        <div class="header-user-trigger">
          <img
            class="header-user-avatar"
            src="../assets/images/header-avatar.svg"
            alt=""
          />
          <!-- <span class="header-user-text">{{ userName }}</span> -->
          <span class="header-user-text">{{ userPhone }}</span>
          <span class="header-user-jt"></span>
        </div>

        <transition name="tip">
          <ul
          v-if="activeDown === 'user'"
            class="header-user-list"
            :style="{ width: language === 'zh_CN' ? '220px' : '255px' }"
          >
            <li class="user-message">
              <div class="left">
                <div class="user-message-name">{{ userName }}</div>
                <div class="user-message-phone">{{ userPhone }}</div>
              </div>
              <div class="right">
                <img src="../assets/images/v4_gly.png" alt="" />
                <div class="admin-text">
                  <span v-if="roleType === 1">
                    <!--  平台管理员 -->
                    {{ $t("lanV4.adminTxt2") }}
                  </span>
                  <span v-if="roleType === 0">
                    <!-- 商户管理员 -->
                    {{ $t("lanV4.adminTxt1") }}
                  </span>
                  <span v-if="roleType === 3 || roleType === 4">
                    <!-- 合约经纪人 -->
                    {{ $t("lanV4.futuresBroker") }}
                  </span>
                </div>
              </div>
            </li>
            <!-- <li
              class="user-option"
              @click="setGoogleAlert(true)"
              @mouseover="userIndex = 0"
            >
              <img
                class="v4_20"
                v-if="userIndex === 0"
                src="../assets/images/v4_20_h.svg"
                alt=""
              />
              <img
                v-else
                class="v4_20"
                src="../assets/images/v4_20.svg"
                alt=""
              />
              绑定Google
              <span :class="{ activeColor: userIndex === 0 }">{{
                googleIsOpen === "0"
                  ? $t("header.google.bind")
                  : $t("header.google.unBind")
              }}</span>
              <svg
                class="icon active-icon"
                aria-hidden="true"
                v-if="userIndex === 0"
              >
                <use xlink:href="#icon-v4_19"></use>
              </svg>
            </li> -->
            <!-- <li
              v-if="this.user && !this.user.isChainUpSaas"
              class="user-option"
              @click="setPasswordAlert(true)"
              @mouseover="userIndex = 1"
            >
              <svg
                class="icon icon-14"
                aria-hidden="true"
                v-if="userIndex === 1"
              >
                <use xlink:href="#icon-v4_23_h"></use>
              </svg>
              <svg class="icon icon-14" aria-hidden="true" v-else>
                <use xlink:href="#icon-v4_23"></use>
              </svg>
              修改密码
              <span :class="{ activeColor: userIndex === 1 }">{{
                $t("header.setpass")
              }}</span>
              <svg
                class="icon active-icon"
                aria-hidden="true"
                v-if="userIndex === 1"
              >
                <use xlink:href="#icon-v4_19"></use>
              </svg>
            </li> -->
            <li
              class="user-option"
              @click="outLogin"
              @mouseover="userIndex = 2"
              v-if="false"
            >
              <!--      v-if="this.user && !this.user.isChainUpSaas" -->
              <svg
                class="icon icon-14"
                aria-hidden="true"
                v-if="userIndex === 2"
              >
                <use xlink:href="#icon-v4_22_h"></use>
              </svg>
              <svg class="icon icon-14" aria-hidden="true" v-else>
                <use xlink:href="#icon-v4_22"></use>
              </svg>
              <!-- 退出登录 -->
              <span :class="{ activeColor: userIndex === 2 }">{{
                $t("header.outLogin")
              }}</span>
              <svg
                class="icon active-icon"
                aria-hidden="true"
                v-if="userIndex === 2"
              >
                <use xlink:href="#icon-v4_19"></use>
              </svg>
            </li>
          </ul>
        </transition>
      </div>
      <!--多语言切换-->
      <div
        class="header-lang"
        @mouseleave="downLeave('lang')"
        @mouseenter="downEnter('lang')"
      >
        <!-- {{ showLangText }} -->
        <div class="show-lang-text">
          <div
            class="show-lang-text-bor"
            v-if="this.user && !this.user.isChainUpSaas"
          ></div>
          <svg
            class="icon icon-18 icon-lang"
            aria-hidden="true"
            v-if="lanHoverIndex === 1"
          >
            <use xlink:href="#icon-v4_18_h"></use>
          </svg>
          <svg v-else class="icon icon-18 icon-lang" aria-hidden="true">
            <use xlink:href="#icon-v4_18"></use>
          </svg>
        </div>
        <transition name="tip">
          <div class="header-downList lang-list" v-if="activeDown === 'lang'">
            <div
              class="header-downList-even"
              @click="langClick(item.langKey)"
              :class="
                language === item.langKey ? 'header-downList-active' : ''
              "
              v-for="(item, index) in lanList"
              :key="index"
            >
              <span style="margin-left: 12px">{{ item.langName }}</span>
              <svg
                v-if="language === item.langKey"
                class="icon icon-16 active-icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-v4_19"></use>
              </svg>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!--谷歌验证码-->
    <b-modal
      :title="
        googleIsOpen === '0'
          ? $t('header.google.bind')
          : $t('header.google.unBind')
      "
      scrollable
      size="lg"
      v-model="googleAlert"
      no-close-on-backdrop
      id="header-google"
    >
      <!-- 谷歌 -->
      <bindGoogle
        @googleBtnDisable="googleBtnDisable"
        ref="bindGoogle"
        @googleClose="setGoogleAlert(false)"
      />
      <div class="deilog-bottom" slot="modal-footer">
        <b-button
          class="coustom-btn submit-google"
          :disabled="googDisable"
          variant="primary"
          @click="googleSubmit"
          >{{ $t("header.setPass.yes") }}</b-button
        >
        <!-- <b-button class="coustom-btn" @click="setGoogleAlert(false)">{{
          $t("header.setPass.no")
        }}</b-button> -->
      </div>
    </b-modal>
    <!--修改登录密码-->
    <b-modal
      :title="$t('header.setPass.title')"
      scrollable
      v-model="passwordAlert"
      no-close-on-backdrop
      id="header-setPassword"
    >
      <div class="header-setPassword-content">
        <input name="username" type="text" class="NOAUTO" />
        <input name="password" type="password" class="NOAUTO" />
        <div class="setpass-input-box">
          <!-- 用户昵称 -->
          <label
            ><i class="text-danger"></i>{{ $t("header.setPass.user") }}</label
          >
          <b-form-input
            :value="userName"
            :state="null"
            :disabled="true"
            class="passwordInput"
          >
          </b-form-input>
        </div>
        <div class="setpass-input-box position-relative">
          <!-- 旧密码 -->
          <label
            ><i class="text-danger"></i>{{ $t("header.setPass.old") }}</label
          >
          <b-form-input
            v-model="oldpass"
            :state="oldpassShowError"
            :type="oldPassword.inputType"
            class="passwordInput"
            :placeholder="$t('header.setPass.oldError')"
          >
          </b-form-input>
          <eye-password
            class="eye-pwd position-absolute"
            :passwordType="oldPassword"
            @currentType="eyeChange"
          ></eye-password>
          <b-form-invalid-feedback>
            <!-- 请输入8-16位数字和字母密码 -->
            {{ $t("header.setPass.oldError") }}
          </b-form-invalid-feedback>
        </div>
        <div class="setpass-input-box position-relative">
          <!-- 新密码 -->
          <label
            ><i class="text-danger"></i> {{ $t("header.setPass.new") }}
          </label>
          <b-form-input
            v-model="newpass"
            :state="newpassShowError"
            :type="newPassword.inputType"
            class="passwordInput"
            :placeholder="$t('header.setPass.newError')"
          >
          </b-form-input>
          <eye-password
            class="eye-pwd position-absolute"
            :passwordType="newPassword"
            @currentType="eyeChange"
          ></eye-password>
          <b-form-invalid-feedback>
            <!-- 请输入8-16位数字和字母密码 -->
            {{ $t("header.setPass.newError") }}
          </b-form-invalid-feedback>
        </div>
        <div class="setpass-input-box position-relative">
          <!-- 确认新密码 -->
          <label
            ><i class="text-danger"></i>{{ $t("header.setPass.com") }}</label
          >
          <b-form-input
            v-model="compass"
            :state="compassShowError"
            :type="newTwoPassword.inputType"
            class="passwordInput"
            :placeholder="$t('header.setPass.newError')"
          >
          </b-form-input>
          <eye-password
            class="eye-pwd position-absolute"
            :passwordType="newTwoPassword"
            @currentType="eyeChange"
          ></eye-password>
          <b-form-invalid-feedback>
            <!-- 两次新密码不一致 -->
            {{ $t("header.setPass.comError") }}
          </b-form-invalid-feedback>
        </div>
      </div>
      <div class="deilog-bottom" slot="modal-footer">
        <b-button class="coustom-btn" @click="setPasswordAlert(false)">{{
          $t("header.setPass.no")
        }}</b-button>
        <b-button
          class="coustom-btn"
          variant="primary"
          :disabled="passBtnDisabled"
          @click="setPassClick"
          >{{ $t("header.setPass.yes") }}</b-button
        >
      </div>
    </b-modal>
  </section>
</template>
<script>
import { Header as AppHeader, AsideToggler } from "@coreui/vue";
import bindGoogle from "./bindGoogle";
import { setCookie, removeCookie, getCookie } from "@/apis/cookie";
import EyePassword from "../components/eyePassword";
export default {
  name: "templateArch-header",
  components: {
    AppHeader,
    AsideToggler,
    bindGoogle,
    EyePassword,
  },
  props: {
    headerActive: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      activeDown: null, // 当前选中的下拉框
      googleAlert: false, // 谷歌弹窗
      passwordAlert: false, // 修改密码弹窗
      outFlag: true, // 退出登录防二次点击
      userName: "", // 用户名称
      userPhone: "", // 手机号码
      uid: "", // 用户id
      oldpass: "", // 旧密码
      newpass: "", // 新密码
      compass: "", // 确认密码
      setPassFlag: true, // 密码弹窗防二次点击
      lanList: [],
      logo: "",
      googDisable: true, // 谷歌验证弹窗 disabled
      oldPassword: {
        inputType: "password",
        label: "oldPwd",
      },
      newPassword: {
        inputType: "password",
        label: "newPwd",
      },
      newTwoPassword: {
        inputType: "password",
        label: "newTwoPwd",
      },
      brokerId: null,
      userIndex: null,
      userHoverIndex: null,
      lanHoverIndex: null,
    };
  },
  created() {
    this.$bus.$on("setGoogleAlert", (v) => {
      this.setGoogleAlert(v);
    });
    if (this.headerActive.length) {
      this.init();
    }
    if (this.user) {
      this.userInit();
    }
    if (this.public) {
      this.publicInit();
    }
  },
  watch: {
    headerActive(v) {
      if (v.length) {
        this.init();
      }
    },
    user(v) {
      if (v) {
        this.userInit();
      }
    },
    public(v) {
      if (v) {
        this.publicInit();
      }
    },
    passwordAlert(v) {
      if (v) {
        this.setPassFlag = true;
        this.oldpass = "";
        this.newpass = "";
        this.compass = "";
      }
    },
  },
  computed: {
    googleIsOpen() {
      let num = "0";
      const { user } = this.$store.state.baseData;
      if (user && user.googleStatus != null) {
        num = user.googleStatus.toString();
      }
      return num;
    },
    showLangText() {
      let str = "";
      if (
        this.public &&
        this.public.lan &&
        this.language &&
        this.language.length
      ) {
        this.lanList.forEach((item) => {
          if (item.langType === this.language) {
            str = item.showName;
          }
        });
      }
      return str;
    },
    passBtnDisabled() {
      let flag = true;
      if (this.oldpassFlag && this.newpassFlag && this.compassFlag) {
        flag = false;
      }
      return flag;
    },
    oldpassShowError() {
      if (this.oldpass.length) {
        if (this.oldpassFlag) {
          return null;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    newpassShowError() {
      if (this.newpass.length) {
        if (this.newpassFlag) {
          return null;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    compassShowError() {
      if (this.compass.length) {
        if (this.compassFlag) {
          return null;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    oldpassFlag() {
      return this.passReg.test(this.oldpass);
    },
    newpassFlag() {
      return this.passReg.test(this.newpass);
    },
    compassFlag() {
      return this.compass === this.newpass;
    },
    passReg() {
      return this.$store.state.regExp.passWord;
    },
    language() {
      return this.$store.state.baseData.language;
    },
    user() {
      return this.$store.state.baseData.user;
    },
    public() {
      return this.$store.state.baseData.public;
    },
    menus() {
      return this.$store.state.baseData.menus;
    },
    HeaderAtName() {
      return this.$store.state.baseData.HeaderAtName;
    },
    HeaderChildName() {
      return this.$store.state.baseData.HeaderChildName;
    },
    // 角色类型
    roleType() {
      if (this.$store.state.baseData.user) {
        return this.$store.state.baseData.user.roleType;
      }
    },
  },
  methods: {
    eyeChange(v) {
      if (v.label === this.oldPassword.label) {
        this.oldPassword.inputType = v.inputType;
      } else if (v.label === this.newPassword.label) {
        this.newPassword.inputType = v.inputType;
      } else if (v.label === this.newTwoPassword.label) {
        this.newTwoPassword.inputType = v.inputType;
      }
    },
    googleBtnDisable(v) {
      this.googDisable = v;
    },
    langClick(v) {
      setCookie("lan", v);
      window.location.reload();
    },
    publicInit() {
      // const { lan } = this.$store.state.baseData.public;
      // this.lanList = lan;
      const { languageConfList } = this.$store.state.baseData;
      this.lanList = languageConfList;
     
    },
    setPassClick() {
      if (!this.setPassFlag) return;
      this.setPassFlag = false;
      this.$http({
        url: "admin_user_edit_password_submit",
        params: {
          uid: this.uid,
          oldPword: this.oldpass,
          newPword: this.newpass,
        },
      }).then(({ code, msg }) => {
        this.setPassFlag = true;
        if (code.toString() === "0") {
          this.$bus.$emit("alert", {
            type: "success",
            message: "密码修改成功，请重新登录",
          });
          this.passwordAlert = false;
          this.setPassFlag = true;
          // setCookie("admin-broker-id", "");
          setCookie("admin-token", "");
          window.location.href = "/noLogin";
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    userInit() {
      const { mobileNumber, nickname, uid, email } = this.user;
      this.userName = nickname;
      this.uid = uid;
      this.userPhone = mobileNumber || email;
    },
    outLogin() {
      if (!this.outFlag) return;
      this.outFlag = false;
      this.$http({
        url: "login_out",
      }).then(({ code, msg }) => {
        this.outFlag = true;
        if (code.toString() === "0") {
          this.$bus.$emit("alert", {
            type: "success",
            message: this.$t("lanV4.outLogin"),
          });
          removeCookie("admin-broker-id");
          sessionStorage.removeItem("editableTabs");
          if (
            getCookie("lan") !== "zh_CN" &&
            getCookie("lan") !== "en_US" &&
            getCookie("lan") !== "el_GR"
          ) {
            removeCookie("lan");
          }
          window.location.href = "/noLogin";
          // setTimeout(() => {
          //   location.reload();
          // }, 500);
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    setGoogleAlert(v) {
      this.googleAlert = v;
      if (!v) {
        this.$refs.bindGoogle.reset();
      }
    },
    googleSubmit() {
      this.$refs.bindGoogle.submit();
    },
    setPasswordAlert(v) {
      this.passwordAlert = v;
    },
    downLeave(v) {
      this.activeDown = -1;
      if (v === "user") this.userHoverIndex = 0;
      if (v === "lang") this.lanHoverIndex = 0;
    },
    downEnter(v) {
      this.activeDown = v;
      if (v === "user") this.userHoverIndex = 1;
      if (v === "lang") this.lanHoverIndex = 1;
    },
    headerFilter(arr) {
      let flag = false;
      arr.forEach((item) => {
        if (item.atName === this.headerActive) {
          flag = true;
        }
      });
      return flag;
    },
    init() {
      const { navList } = this.menus;
      const obj = {};
      // 经纪人添加-------
      // navList.push({
      //   id: 200,
      //   parentId: 0,
      //   atName: "agentBoard",
      //   atDes: "看板",
      //   atUrl: "",
      //   ctime: "2019-07-15T21:05:00",
      //   mtime: "2022-09-08T14:29:00",
      //   atType: 1,
      //   sortCode: 0,
      //   child: [],
      // },{
      //   id: 201,
      //   parentId: 0,
      //   atName: "agentRebate",
      //   atDes: "返佣",
      //   atUrl: "",
      //   ctime: "2019-07-15T21:05:00",
      //   mtime: "2022-09-08T14:29:00",
      //   atType: 1,
      //   sortCode: 0,
      //   child: [],
      // },{
      //   id: 202,
      //   parentId: 0,
      //   atName: "allOverview",
      //   atDes: "用户管理",
      //   atUrl: "",
      //   ctime: "2019-07-15T21:05:00",
      //   mtime: "2022-09-08T14:29:00",
      //   atType: 1,
      //   sortCode: 0,
      //   child: [],
      // },{
      //   id: 203,
      //   parentId: 0,
      //   atName: "agentManage",
      //   atDes: "经纪人管理",
      //   atUrl: "",
      //   ctime: "2019-07-15T21:05:00",
      //   mtime: "2022-09-08T14:29:00",
      //   atType: 1,
      //   sortCode: 0,
      //   child: [],
      // },{
      //   id: 204,
      //   parentId: 0,
      //   atName: "agentSystem",
      //   atDes: "系统设置",
      //   atUrl: "",
      //   ctime: "2019-07-15T21:05:00",
      //   mtime: "2022-09-08T14:29:00",
      //   atType: 1,
      //   sortCode: 0,
      //   child: [],
      // },{
      //   id: 205,
      //   parentId: 0,
      //   atName: "agentUseGuide",
      //   atDes: "使用指南",
      //   atUrl: "",
      //   ctime: "2019-07-15T21:05:00",
      //   mtime: "2022-09-08T14:29:00",
      //   atType: 1,
      //   sortCode: 0,
      //   child: [],
      // });
      // 经纪人添加-----
      navList.forEach((item) => {
        if (item.child && item.child.length) {
          item.child.forEach((citem) => {
            obj[citem.atName] = item.atName;
          });
        } else {
          obj[item.atName] = item.atName;
        }
      });
    },
    headerClick(v) {
      this.$emit("setHeaderActive", v);
    },
  },
};
</script>
<style lang="scss">
.header-bg {
  background: #fff;
}
.headerLink-cl {
  color: #828ea1;
}
.headerActive-cl {
  color: #095be8;
}

@media (max-width: 992px) {
  .header-navlist {
    display: none;
  }
}
#header-google {
  @media (min-width: 992px) {
    .modal-dialog {
      width: 480px !important;
    }
  }
  .submit-google {
    width: 380px;
    margin-right: 0px;
    height: 40px;
    &:disabled {
      background: #828ea1 !important;
      opacity: 1 !important;
    }
  }
  .deilog-bottom {
    padding-bottom: 14px;
  }
  .modal-body {
    padding-bottom: 0px !important;
  }
}
#header-setPassword {
  @media (min-width: 992px) {
    .modal-dialog {
      width: 600px !important;
    }
  }
  .header-setPassword {
    margin-top: 10px;
  }
  .setpass-input-box {
    position: relative;
    padding-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
    margin: 0 15px;

    .eye-pwd {
      top: 40px;
      right: 6px;
      z-index: 10;
    }
    .invalid-feedback {
      position: absolute;
      bottom: 0;
    }
    .form-control {
      display: block;
      &:disabled {
        background: #e5e6e8 !important;
      }
    }
    label {
      width: 100px;
      font-size: 14px;
      color: #93979d;
      margin-top: 5px;
    }
  }
  input::-webkit-input-placeholder {
    font-size: 12px !important;
  }
  .passwordInput {
    // width: 332px !important;
    height: 32px;
    background: #f7f8fa !important;
  }
}
.cursor {
  cursor: pointer;
}

.common-header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  box-sizing: border-box;
  padding: 0 20px !important;
  z-index: 9;
  // box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.25);
  right: 0;
  @extend .header-bg;
  .header-options {
    float: right;
    .header-lang {
      float: left;
      cursor: pointer;
      position: relative;
      line-height: 70px;
      @extend .headerLink-cl;
      padding-left: 5px;
      transition: all 0.3s;

      .show-lang-text {
        position: relative;
        padding-left: 21px;
        .show-lang-text-bor {
          position: absolute;
          left: 0;
          top: 26px;
          border-left: 1px solid #e0e1e2;
          height: 12px;
        }
        .icon-lang {
          position: relative;
          top: -4px;
        }
      }
      &:hover {
        @extend .headerActive-cl;
        .lang-down {
          @extend .headerActive-cl;
        }
      }
      .lang-list {
        right: 0;
      }
      .lang-down {
        font-size: 12px !important;
        @extend .headerLink-cl;
        margin-left: 4px;
        @extend .cursor;
      }
    }
    .header-user {
      float: left;
      padding: 0 20px;
      position: relative;
      padding-bottom: 30px;
      .v4_20 {
        width: 14px;
        position: relative;
        top: 0px;
      }
      .header-user-text {
        display: inline-block;
        font-size: 14px;
        line-height: 22px;
        color: #384a63;
        margin-left: 10px;
        margin-right: 10px;
      }
      .icon-user {
        margin-top: 20px;
      }
      .header-user-avatar {
        display: inline-block;
        width: 22px;
        height: 22px;
      }
      .header-user-trigger {
        height: 60px;
        display: flex;
        align-items: center;
      }
      &:hover {
        color: #095be8;
        .header-user-text {
          color: #095be8;
        }
        .header-user-jt {
          transform: rotate(180deg);
          border-top: 5px solid #095be8;
        }
        i {
          @extend .headerActive-cl;
        }
      }
      .header-user-list {
        width: 185px;
        position: absolute;
        top: 67px;
        right: 0%;
        // @extend .header-bg;
        background: #fff;
        padding: 10px 0 10px 0;
        border-radius: 4px;
        box-shadow: 3px 3px 10px 0px rgba(191, 202, 228, 0.49);
        .user-message {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 5px;
          margin-bottom: 4px;
          .left {
            width: 110px;
            // overflow: hidden;
            word-break: break-all;
            white-space: pre-wrap;
            .user-message-name {
              width: 100%;
              padding-left: 16px;
              box-sizing: border-box;
              font-size: 14px;
              font-family: "HarmonyOS-Regular";
              font-style: normal;
              font-weight: 500;
              color: #24324c;
            }
            .user-message-phone {
              width: 100%;
              padding-left: 16px;
              box-sizing: border-box;
              font-family: "HarmonyOS-Regular";
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              color: #5c616b;
            }
          }
          .right {
            display: flex;
            padding-left: 7px;

            height: 20px;
            line-height: 20px;
            text-align: center;
            margin-right: 16px;
            margin-top: 14px;
            img {
              width: 10px;
              height: 7.8px;
              position: relative;
              top: 4px;
            }
            border-radius: 30px;
            border: 2px solid #3078ff;
            .admin-text {
              font-family: "HarmonyOS-Regular";
              font-style: normal;
              font-weight: 500;
              font-size: 10px;
              transform: scale(0.83333);
              transform-origin: 0 0;
              color: #3078ff;
              margin-left: 2px;
            }
          }
        }

        .user-option {
          padding-left: 18px;
          width: 100%;
          box-sizing: border-box;
          height: 35px;
          line-height: 35px;
          position: relative;
          .active-icon {
            position: absolute;
            right: 16px;
            top: 11px;
          }
          .activeColor {
            color: #095be8;
          }
          cursor: pointer;
          i {
            @extend .headerLink-cl;
          }
          span {
            @extend .headerLink-cl;
            margin-left: 10px;
            // width: 100px;
            display: inline-block;
            // overflow: hidden;
            height: 24px;
            position: relative;
            top: 0px;
            color: #24324c;
            font-family: "HarmonyOS-Regular";
          }
          &:hover {
            i,
            span {
              @extend .headerActive-cl;
            }
          }
        }
      }
      .header-user-jt {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #8d9198;
        position: relative;
      }
    }
    .option-icon {
      cursor: pointer;
      font-size: 18px;
      line-height: 60px;
      @extend .headerLink-cl;
      // font-weight: 700;
    }
  }
  .header-downList {
    position: absolute;
    top: 67px;
    // @extend .header-bg;
    background: #fff;
    // padding: 10px 0;
    color: #5c616b;
    border-radius: 4px;
    box-shadow: 3px 3px 10px 0px rgba(82, 63, 105, 0.25);
    padding-top: 9px;
    padding-bottom: 9px;
    .header-downList-even {
      min-width: 120px;
      padding: 11px 15px;
      line-height: 15px;
      font-size: 12px;
      // text-align: center;
      box-sizing: content-box;
      transition: all 0.1s;
      color: #5c616b;
      position: relative;
      font-family: "HarmonyOS-Regular";
      font-style: normal;
      font-weight: 600;
      @extend .headerLink-cl;
      @extend .cursor;
      &:hover {
        // background: #3e4d66;
        color: #095be8;
        background: #fff;
        @extend .headerActive-cl;
      }
      .active-icon {
        position: absolute;
        right: 16px;
        top: 9px;
      }
    }
    .header-downList-active {
      @extend .headerActive-cl;
      // background: #3e4d66;
      color: #095be8;
    }
  }
}
.headersideBtn {
  position: fixed;
  left: -1000px;
  height: -1000px;
}
.tip-item-move {
  display: inline-block;
  margin-right: 10px;
}
.tip-enter-active,
.tip-leave-active {
  transition: all 0.3s;
}
.tip-enter, .tip-leave-to
    /* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translate3d(1%, 3%, 0);
}
@media (max-width: 1450px) {
  // .header-options {
  //   display: none;
  // }
}
</style>
